import { get, post, put, destroy } from '@/api/request';

function fetchTimesheets(params) {
  return get('/timesheets', params);
}

function fetchSingleTimesheet(id) {
  return get(`/timesheets/${id}`);
}

function createTimesheet(data) {
  return post('/timesheets', data);
}

function updateTimesheet(timesheetId, data) {
  return put(`/timesheets/${timesheetId}`, data);
}

function deleteTimesheet(timesheetId) {
  return destroy(`/timesheets/${timesheetId}`);
}

function changeStatus({ id, data }) {
  return put(`timesheets/${id}`, data);
}

function fetchRejectedTimesheets(data) {
  return post('/timesheets/rejected', data);
}

function fetchPendingTimesheets(params) {
  return get('/timesheets/pending', params);
}
function fetchBMSReport(params) {
  return get('/timesheets/bmsreport', params);
}

function triggerBmsSync(data) {
  return post('/timesheets/bms-sync', data);
}

function fetchBmsSyncStatus(jobId) {
  return get(`/timesheets/bms-sync/${jobId}`);
}

function fetchBmsSyncHistory(params) {
  return get('/timesheets/bms-sync', params);
}
export default {
  fetchTimesheets,
  fetchSingleTimesheet,
  createTimesheet,
  updateTimesheet,
  deleteTimesheet,
  changeStatus,
  fetchRejectedTimesheets,
  fetchPendingTimesheets,
  fetchBMSReport,
  triggerBmsSync,
  fetchBmsSyncStatus,
  fetchBmsSyncHistory,
};



// WEBPACK FOOTER //
// ./src/store/modules/timesheet/api.js